var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumbersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "numbers-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "numbers-icon-group2",
    transform: "translate(-93.000000, -569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "numbers-icon-group3",
    transform: "translate(93.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "numbers-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2162162,25.5255255 L28.2162162,6.69069069 C28.2162162,5.21081081 27.0054054,4 25.5255255,4 L6.69069069,4 C5.21081081,4 4,5.21081081 4,6.69069069 L4,25.5255255 C4,27.0054054 5.21081081,28.2162162 6.69069069,28.2162162 L25.5255255,28.2162162 C27.0054054,28.2162162 28.2162162,27.0054054 28.2162162,25.5255255 Z",
    id: "numbers-icon-path1",
    fill: "#42CC3E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "numbers-icon-group4",
    transform: "translate(9.000000, 10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "numbers-icon-rectangle1",
    x: 0,
    y: 7.77777778,
    width: 2.33333333,
    height: 3.88888889
  }), /*#__PURE__*/React.createElement("rect", {
    id: "numbers-icon-rectangle2",
    x: 11.6666667,
    y: 3.11111111,
    width: 2.33333333,
    height: 8.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "numbers-icon-rectangle3",
    x: 7.77777778,
    y: 0,
    width: 2.33333333,
    height: 11.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "numbers-icon-rectangle4",
    x: 3.88888889,
    y: 5.44444444,
    width: 2.33333333,
    height: 6.22222222
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersIcon);
export default __webpack_public_path__ + "static/media/numbers-icon.ada7a7d0.svg";
export { ForwardRef as ReactComponent };